<script lang="ts">
export default {
  name: 'LimitPremiumCounterToggle',
};
</script>

<script setup lang="ts">
import { StoreMutationType } from '@/types/StoreMutationType';
import { computed, inject } from 'vue';
import { Store } from 'vuex';
import { AppState } from '@/store';
import { Book, BookOpen } from '@lucide/vue';

// ---------------
// reactive data
// ---------------
const store = inject<Store<AppState>>('store');

// ----------
// computed
// ----------
const limitPremiumCounterEnabled = computed<boolean | undefined>(() => {
  return store?.state.towerCanvasState.limitPremiumCounterEnabled;
});

// ----------
// handlers
// ----------
function handleToggleLimitPremiumCounter(e: MouseEvent): void {
  e.stopPropagation();
  store?.commit(
    StoreMutationType.SET_LIMIT_PREMIUM_COUNTER_MODE,
    !store?.state.towerCanvasState.limitPremiumCounterEnabled,
  );
}
</script>

<template>
  <div class="self-end py-2">
    <label title="Toggle Limit Premium Counter">
      <input
        type="checkbox"
        name="limit-premium-counter-toggle"
        aria-label="Limit Premium Counter Toggle"
        class="pointer-events-none box-border hidden"
        @click="handleToggleLimitPremiumCounter"
      />
      <div
        class="border-box pointer-events-auto flex h-10 w-10 cursor-pointer items-center justify-center rounded-lg border border-solid border-(--tower-v2-border-color) bg-(--tower-v2-tool-selected-color) shadow-lg hover:bg-[--tower-v2-hover-color]"
      >
        <BookOpen v-if="limitPremiumCounterEnabled" />
        <Book v-else />
      </div>
    </label>
  </div>
</template>
